import api, { uploadApi } from './axios';

/**
 * Get all conversations for the current user
 * @returns {Promise} Promise object representing the API response
 */
export const getConversations = () => {
  return api.get('/chat/conversations');
};

/**
 * Get messages between the current user and another user
 * @param {string} userId - ID of the other user
 * @param {Object} options - Pagination options
 * @param {number} options.page - Page number
 * @param {number} options.limit - Items per page
 * @returns {Promise} Promise object representing the API response
 */
export const getMessagesByUserId = (userId, options = {}) => {
  const { page = 1, limit = 10 } = options;
  
  return api.get(`/chat/${userId}`, {
    params: {
      page,
      limit,
    },
  });
};

/**
 * Send a message to another user
 * @param {string} userId - ID of the recipient user
 * @param {Object} messageData - Message data
 * @param {string} messageData.content - Message content
 * @param {File[]} messageData.media - Array of media files (optional)
 * @param {Function} onUploadProgress - Progress callback
 * @returns {Promise} Promise object representing the API response
 */
export const sendMessage = (userId, messageData, onUploadProgress) => {
  const { content, media = [], attachements } = messageData;
  
  const formData = new FormData();
  formData.append('content', content);
  formData.append('attachements', JSON.stringify(attachements));
  
  // Append multiple media files
  media.forEach((file) => {
    formData.append('media', file);
  });
  
  return uploadApi(`/chat/${userId}`, formData, onUploadProgress);
};

/**
 * Mark a message as read
 * @param {string} messageId - Message ID
 * @returns {Promise} Promise object representing the API response
 */
export const markMessageAsRead = (messageId) => {
  return api.put(`/chat/messages/${messageId}/read`);
};

/**
 * Mark all messages in a conversation as read
 * @param {string} userId - ID of the other user in the conversation
 * @returns {Promise} Promise object representing the API response
 */
export const markConversationAsRead = (userId) => {
  // return api.put(`/chat/${userId}/read`);
};

/**
 * Delete a message
 * @param {string} messageId - Message ID
 * @returns {Promise} Promise object representing the API response
 */
export const deleteMessage = (messageId) => {
  return api.delete(`/chat/messages/${messageId}`);
};